import { createSlice } from "@reduxjs/toolkit";

export const notificationSocketInstance = createSlice({
  name: "notification_socket_instance",
  initialState: {
    value: {
      status: false,
      socketInstance: null,
    },
  },
  reducers: {
    updateSocketInstance: (state, action) => {
      state.value.status = true;
      state.value.socketInstance = action.payload;
    },
  },
});

export const { updateSocketInstance } = notificationSocketInstance.actions;

export default notificationSocketInstance.reducer;
